<main *transloco="let t">
  <section class="wallpaper"></section>

  <section class="content">
    <div class="state-wrapper">
      <div class="logo-wrapper"><p class="logo"></p></div>

      <div class="icon-circle info-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle cx="12" cy="12" r="9" stroke="#ffffff" stroke-width="2.5" />
          <line
            x1="12"
            y1="8"
            x2="12"
            y2="12"
            stroke="#ffffff"
            stroke-width="2.5"
            stroke-linecap="round"
          />
          <circle cx="12" cy="16" r="1.2" fill="#ffffff" />
        </svg>
      </div>

      <h2>{{ t('Pet Share Invite') }}</h2>

      <p class="description">
        {{
          t(
            'You have a pending pet data share invite. Open the Anihis app to accept or decline it.'
          )
        }}
      </p>

      <p class="countdown">
        {{ t('Opening the app in') }} <strong>{{ countdown() }}</strong>
        {{ t('seconds.') }}
      </p>

      <button class="open-app-btn" (click)="openApp()">
        {{ t('Open Anihis App') }}
      </button>

      <p class="hint">
        {{ t("Don't have the app yet?") }}
      </p>

      <a
        class="store-link"
        [href]="getAppStoreUrl()"
        target="_blank"
        rel="noopener"
      >
        {{ t('Download Anihis') }}
      </a>
    </div>
  </section>
</main>
